import { css } from '@emotion/react';
import { PersonTypes } from '@frontend/api-person';
import { theme } from '@frontend/theme';
import { NakedUl } from '@frontend/design-system';
import { useScheduleAppointmentInfoPanelShallowStore } from '../../../stores/schedule-appointment-info-panel.store';
import { ExtendedAppointment } from '../../../types';
import { AppointmentListItem } from '../appointment-list-item';
import { AppointmentFloatingActions } from './appointment-floating-actions';

interface Props {
  appointments: ExtendedAppointment[];
}

export const AppointmentList = ({ appointments }: Props) => {
  const { setSelectedAppointment } = useScheduleAppointmentInfoPanelShallowStore('setSelectedAppointment');
  return (
    <NakedUl css={listStyle}>
      {appointments.map((appointment) => {
        if (!appointment.locationId || !appointment.person) return null;
        return (
          <li key={appointment.id} css={itemContainerStyle} onClick={() => setSelectedAppointment(appointment)}>
            <AppointmentFloatingActions
              locationId={appointment.locationId}
              // TODO: validate whether this is correct or not
              person={appointment.person as PersonTypes.Person}
            >
              <AppointmentListItem appointment={appointment} />
            </AppointmentFloatingActions>
          </li>
        );
      })}
    </NakedUl>
  );
};

const listStyle = css({
  flex: 1,
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  background: theme.colors.neutral5,
});

const itemContainerStyle = css({
  border: `1px solid ${theme.colors.neutral20}`,
  borderRadius: theme.borderRadius.medium,
  backgroundColor: theme.colors.white,
  transition: 'box-shadow 0.2s ease-in-out',
  ':hover': {
    boxShadow: theme.shadows.light,
    cursor: 'pointer',
  },
});
